import Vue from 'vue';

import activityFeedService from '@d-services/activity-feed-service/activity-feed-service';
import { getErrorMessage } from '@d-shared/utils/errors';

export default {
  props: {
    activity: {
      type: Object,
      required: true,
    },
    canVote: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isVoting: false,
  }),
  methods: {
    async pickPostOption(option) {
      if (!this.canVote) {
        return false;
      }

      let voteSuccessful = false;
      this.$set(this, 'isVoting', true);

      try {
        await activityFeedService.pickPostOption(this.activity.slug, option);
        Vue.duiNotificationManager.success('Your vote has been registered!');
        voteSuccessful = true;
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isVoting', false);
      return voteSuccessful;
    },
  },
};
